import * as Styled from './RisksControlsGaps.styled';
import * as ReportingStyled from '../Reporting.styled';
import dayjs from 'dayjs';

const formatDate = (date: string | null) => {
  if (!date) return null;
  try {
    return dayjs(date).format('YYYY-MM-DD');
  } catch {
    return date;
  }
};

export const processRiskControlColumns = (data: any[] = []) => {
  const hasValue = (field: string) =>
    data.some(
      (item) =>
        item?.[field] !== null &&
        item?.[field] !== undefined &&
        item?.[field] !== ''
    );

  const organizationalColumns = [
    {
      title: 'Group',
      dataIndex: 'group_name',
      key: 'group_name',
      width: 120
    },
    {
      title: 'Division',
      dataIndex: 'division_name',
      key: 'division_name',
      width: 120
    },
    {
      title: 'Region',
      dataIndex: 'region_name',
      key: 'region_name',
      width: 120
    },
    {
      title: 'Legal Entity',
      dataIndex: 'legal_entity_name',
      key: 'legal_entity_name',
      width: 120
    },
    {
      title: 'Business Unit',
      dataIndex: 'business_unit_name',
      key: 'business_unit_name',
      width: 120
    }
  ].filter((column) => hasValue(column.dataIndex));

  return [
    ...organizationalColumns,
    {
      title: 'Risk',
      dataIndex: 'risk_title',
      key: 'risk_title',
      width: 120
    },
    {
      title: 'Severity',
      dataIndex: 'risk_instance_severity_name',
      key: 'risk_instance_severity_name',
      width: 80
    },
    {
      title: 'Probability of Occurrence',
      dataIndex: 'risk_instance_probability_of_occurrence_name',
      key: 'risk_instance_probability_of_occurrence_name',
      width: 120
    },
    {
      title: 'Risk Status',
      dataIndex: 'risk_status_name',
      key: 'risk_status_name',
      width: 80
    },
    {
      title: 'Control',
      dataIndex: 'control_name',
      key: 'control_name',
      width: 120
    },
    {
      title: 'Design Effectiveness',
      dataIndex: 'control_instance_design_effectiveness_name',
      key: 'control_instance_design_effectiveness_name',
      width: 120
    },
    {
      title: 'Operating Effectiveness',
      dataIndex: 'control_instance_operating_effectiveness_name',
      key: 'control_instance_operating_effectiveness_name',
      width: 120
    },
    {
      title: 'Control Overall Effectiveness',
      dataIndex: 'control_instance_control_overall_effectiveness_name',
      key: 'control_instance_control_overall_effectiveness_name',
      width: 120
    },
    {
      title: 'Performer TOD',
      dataIndex: 'control_instance_performer_tod_name',
      key: 'control_instance_performer_tod_name',
      width: 120
    },
    {
      title: 'Performer TOE',
      dataIndex: 'control_instance_performer_toe_name',
      key: 'control_instance_performer_toe_name',
      width: 120
    },
    {
      title: 'Business Process Level 4',
      dataIndex: 'business_process_l4_title',
      key: 'business_process_l4_title',
      width: 120
    }
  ];
};
